export default "__VITE_ASSET__4Wdq13qP__"